import React, { useEffect, useState } from "react";
import { Tabs, Layout, Menu } from "antd";
import "./about.css"
import i18n from "../../../i18n";
import { useTranslation } from "react-i18next";

const { TabPane } = Tabs;
const { Sider, Content } = Layout;

const TabContent: React.FC<{ text: string, image: string }> = ({ text, image }) => {
    const [language, setLanguage] = useState(i18n.language);

    return (
        <div style={{ padding: "20px", display: "flex", flexDirection: "column" }}>
            <div className="tab-text-image">{text}</div>
            <img src={ image.replace("/en/", `/${language}/`)} alt={text} />
        </div>
    )
};



const SideTabContent: React.FC<{ active: string, tabs: any }> = ({ active, tabs }) => {
    const tab = tabs.find((t: any) => t.key === active);
    return <div style={{ padding: 20 }}>{tab?.content}</div>;
};

const AboutTabs: React.FC = () => {
    const [language, setLanguage] = useState(i18n.language);
    const { t } = useTranslation();

    const hrCoreTabs = [
        { key: "profile", label: t("📑 Profile"), content: <TabContent text={t("Your personal space — resume, work history, and job info in one place.")} image="/assets/about/tabs/en/1_1.svg" /> },
        { key: "employees", label: t("📋 Employees list"), content: <TabContent text={t("Browse, filter, and manage all employees easily.")} image="/assets/about/tabs/en/1_2.svg" /> },
        { key: "salaries", label: t("💲 Salaries"), content: <TabContent text={t("See salary breakdowns by hour, month, and latest payouts.")} image="/assets/about/tabs/en/1_3.svg" /> },
    ];
    
    const workManagmentTabs = [
        { key: "projects", label: t("📈 Projects"), content: <TabContent text={t("Plan and manage all work in Kanban or List view.")} image="/assets/about/tabs/en/2_1.svg" /> },
        { key: "events", label: t("🕧 Events & Time tracking"), content: <TabContent text={t("Track every hour by user or project. View sick leaves, vacations, birthdays.")} image="/assets/about/tabs/en/2_2.svg" /> },
        { key: "tasks", label: t("🎯 Tasks"), content: <TabContent text={t("Reminders, approvals, and personal tasks assigned to you. Stay on top of things.")} image="/assets/about/tabs/en/2_3.svg" /> },
        { key: "calendar", label: t("📅 Calendar"), content: <TabContent text={t("Team, project, and CRM events in a convenient view.")} image="/assets/about/tabs/en/2_4.svg" /> },
        { key: "tests", label: t("🧪 Tests"), content: <TabContent text={t("Assign knowledge tests to team members and monitor results.")} image="/assets/about/tabs/en/2_5.svg" /> },
    ];
    
    const businessToolsTabs = [
        { key: "erp", label: t("💻 Mini ERP"), content: <TabContent text={t("Track income and expenses in a simple, no-fuss format.")} image="/assets/about/tabs/en/3_1.svg" /> },
        { key: "crm", label: t("📞 Mini CRM"), content: <TabContent text={t("Store contacts, meetings, and partner interactions in one clean panel.")} image="/assets/about/tabs/en/3_2.svg" /> },
        { key: "api", label: t("🌐 API Integration"), content: <TabContent text={t("Sync SkTech with your tools via open API.")} image="/assets/about/tabs/en/3_3.svg" /> },
        { key: "support", label: t("🤝 Support Panel"), content: <TabContent text={t("Support center for the team and customers - everything is separate.")} image="/assets/about/tabs/en/3_4.svg" /> },
    ];
    const [activehrCoreTabs, setActivehrCoreTabs] = React.useState("profile");
    const [activeWorkManagmentTabs, setActiveWorkManagmentTabs] = React.useState("projects");
    const [activeBusinessToolsTabs, setActiveBusinessToolsTabs] = React.useState("erp");

    useEffect(() => {
        const handleLanguageChange = () => {
            setLanguage(i18n.language);
        };

        i18n.on("languageChanged", handleLanguageChange);
        return () => {
            i18n.off("languageChanged", handleLanguageChange);
        };
    }, []);

    return (
        <Tabs className="about-custom-tabs" defaultActiveKey="core" type="card" style={{ width: 1100, margin: "50px auto" }}>
            <TabPane tab={t("📁 Core HR Tools")} key="core">
                <Layout style={{ minHeight: 300, background: "#fff", border: "none" }}>
                    <Content className="tab-content">
                        <SideTabContent active={activehrCoreTabs} tabs={hrCoreTabs} />
                    </Content>
                    <Sider width={370} theme="light">
                        <Menu
                            mode="inline"
                            selectedKeys={[activehrCoreTabs]}
                            onClick={({ key }) => setActivehrCoreTabs(key)}
                            style={{ height: "100%" }}
                        >
                            {hrCoreTabs.map((tab) => (
                                <Menu.Item key={tab.key} className="tab-item">{tab.label}</Menu.Item>
                            ))}
                        </Menu>
                    </Sider>
                </Layout>
            </TabPane>

            <TabPane tab={t("📅 Work Management")} key="work" >
                <Layout style={{ minHeight: 300, background: "#fff" }}>
                    <Content className="tab-content">
                        <SideTabContent active={activeWorkManagmentTabs} tabs={workManagmentTabs} />
                    </Content>
                    <Sider width={370} theme="light">
                        <Menu
                            mode="inline"
                            selectedKeys={[activeWorkManagmentTabs]}
                            onClick={({ key }) => setActiveWorkManagmentTabs(key)}
                            style={{ height: "100%" }}
                        >
                            {workManagmentTabs.map((tab) => (
                                <Menu.Item key={tab.key} className="tab-item">{tab.label}</Menu.Item>
                            ))}
                        </Menu>
                    </Sider>
                </Layout>
            </TabPane>

            <TabPane tab={t("🧮 Business Tools")} key="business">
                <Layout style={{ minHeight: 300, background: "#fff" }}>
                    <Content className="tab-content">
                        <SideTabContent active={activeBusinessToolsTabs} tabs={businessToolsTabs} />
                    </Content>
                    <Sider width={370} theme="light">
                        <Menu
                            mode="inline"
                            selectedKeys={[activeBusinessToolsTabs]}
                            onClick={({ key }) => setActiveBusinessToolsTabs(key)}
                            style={{ height: "100%" }}
                        >
                            {businessToolsTabs.map((tab) => (
                                <Menu.Item key={tab.key} className="tab-item">{tab.label}</Menu.Item>
                            ))}
                        </Menu>
                    </Sider>
                </Layout>
            </TabPane>
        </Tabs>
    );
};

export default AboutTabs;
